export default "__VITE_ASSET__CIuULLbE__"